let scrollPosition: number | null = null;

// NOTE: Needed to prevent body scroll on iOS Safari when virtual keyboard is open
// https://bugs.webkit.org/show_bug.cgi?id=141832
export function blockBackgroundScroll(): void {
  const htmlElement = document.querySelector('html');

  if (!htmlElement) {
    return;
  }

  scrollPosition = htmlElement.scrollTop;

  htmlElement.style.position = 'fixed';
  htmlElement.style.width = '100%';
  htmlElement.style.marginTop = `-${scrollPosition}px`;
  if (window.innerHeight < htmlElement.offsetHeight) {
    htmlElement.style.paddingRight = '18px';
  }
}

export function enableBackgroundScroll(): void {
  const htmlElement = document.querySelector('html');

  if (!htmlElement) {
    return;
  }

  htmlElement.style.position = 'unset';
  htmlElement.style.marginTop = 'unset';
  htmlElement.style.width = 'initial';
  if (window.innerHeight < htmlElement.offsetHeight) {
    htmlElement.style.paddingRight = '0px';
  }

  htmlElement.scrollTo({
    top: scrollPosition ?? 0,
  });
}
